<div *ngIf="message"
[ngClass]="{
    'alert-error': message.type==='error',
    'alert-success': message.type!=='error'}">
{{message.text}}
</div>
